import { render } from "./AddNewTradeSpecialism.vue?vue&type=template&id=754eaafc&scoped=true&ts=true"
import script from "./AddNewTradeSpecialism.vue?vue&type=script&lang=ts"
export * from "./AddNewTradeSpecialism.vue?vue&type=script&lang=ts"

import "./AddNewTradeSpecialism.vue?vue&type=style&index=0&id=754eaafc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754eaafc"]])

export default __exports__